import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SubcriptionsView from './SubcriptionsView';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import { dataUtil } from '../../services/wsclients/dataUtil';
import { getCurrency } from '../../utils/commons';
import CustomLoading from '../../components/CustomLoading';
import ChangeServicesView from './ChangeServicesView';
import ServiceDetailView from './ServiceDetailView';
import { ServiceDetailController } from './ServiceDetailController';
import OrderProgress from '../orders/OrderProgress';
import CustomAlert from '../../components/CustomAlert';
import TerminateConfirm from "./TerminateConfirm";
import ChangeBillingDay from '../home/ChangeBillingDay';

export default function SubcriptionsController(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const [showLoading, onShowLoading] = useState(false);
    const [subcriptions, setSubcriptions] = useState(null);
    const [service_requests, setServiceRequests] = useState([]);
    const [periodSelected, setPeriodSelected] = useState(null);
    const [periods, setPeriod] = useState([]);
    const [message, setMessage] = useState({});
    const [changeServices, setChangeServices] = useState([]);
    const [showChangeServices, setShowChangeServices] = useState(false);
    const [subscriptionSelected, setSubcriptionSelected] = useState(null);
    const [showDetailService, setShowDetailService] = useState(false);
    const [serviceChangeSelected, setServiceChangeSelected] = useState(null);
    const [serviceDetail, setServiceDetail] = useState(null);

    const [activeStep, setActiveStep] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [resultProgress, setResultProgress] = useState({
        step: 0,
        status: null,
        code: null,
        message: null
    });
    const [reasonSelected, setReasonSelected] = useState(null);
    const [listReason, setListReason] = useState([]);
    const [showConfirmTerminate, setShowConfirmTerminate] = useState(false);
    const [terminateSelected, setTerminateSelected] = useState(null);
    const [showBillingDay, setShowBillingDay] = useState(false);


    useEffect(() => {
        onInit();
    }, [])

    const onSwarpService = async (subscription) => {
        try{
            onShowLoading(true);
            setSubcriptionSelected(subscription);
            let product = subscription && subscription.service && subscription.service.product ? subscription.service.product : null;
            let result = await wsclients.lab4services.getChangeServices(product && product.id ? product.id : null);
            if(result.code === 'OK'){
                if(result.data){
                    setChangeServices(result.data);
                    setShowChangeServices(true);
                }else{
                    onShowMessage({show: true, content: t('can_not_up_downgrade')});
                }
            }
            onShowLoading(false);
        }
        catch(ex){
            console.log("onSwarpService exception===", ex);
        }
    }

    const onEstimateServices = async (service) => {
        onShowLoading(true)
        try{
            let price = service && service.prices && service.prices.length > 0 ? service.prices[0] : null;
            setServiceChangeSelected(service);
            let result = await wsclients.lab4services.onEstimateServices({
                action: service.change_type,
                from_service_id: subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.id ? subscriptionSelected.service.id : null,
                to_service_id: service && service.id ? service.id : null,
                to_price_terms_id: price && price.id ? price.id : null,
            });
            console.log("result onEstimateServices===", result);
            if(result.code === 'OK'){
                setServiceDetail(result.data);
                setShowDetailService(true);
            }else{
                onShowMessage({show: true, content: t('change_service_failed')})
            }
        }
        catch(ex){
            console.log("onChangeServices exception===", ex);
        }
        onShowLoading(false)
    }

    const onInit = async () => {
        let data = await onLoadSubcriptions();
        if (data && data.length > 0) {
            let periodData = dataUtil.groupBillingPeriod(data);
            console.log("periodData===", periodData);
            if (periodData && periodData.length > 0) {
                setPeriodSelected(periodData[0]);
            }
        }
    }

    const onChangeTab = (period) => {
        setPeriodSelected(period);
    }

    const onLoadSubcriptions = async (isRefresh) => {
        onShowLoading(isRefresh ? false : true);
        var subscriptionServices = [];
        try {
            const result = await wsclients.contacts.getListContactServices();
            console.log("result:", result);
            if (result.code == 'OK') {
                let data = result.data.content ? result.data.content : []
                for (let i = 0; i < data.length; i++) {
                    let subscriptionService = data[i];
                    let product = subscriptionService.service ? subscriptionService.service.product : null;
                    if(subscriptionService.service && subscriptionService.service.price && subscriptionService.service.price.price){
                        product.price = subscriptionService.service.price.price;
                    }
                    if (product) {
                        // let info = await wsclients.contacts.getProductDetail(product.id);
                        let info = await wsclients.lab4services.getServiceProduct(product.id);
                        console.log("product info:", info);
                        if (info.code == 'OK') {
                            console.log("info.data.creatives:", info.data.creatives);
                            product.creatives = info.data.creatives;
                            if(info.data && info.data.price) product.price = info.data.price;
                            product.family = info.data.family ? info.data.family : null;
                            product.type = info.data && info.data.type ? info.data.type : null;
                        }
                    }
                    subscriptionServices.push(subscriptionService);
                }
            }
            console.log("subscriptionServices:", subscriptionServices);
            setSubcriptions(subscriptionServices);
            // setPeriod(dataUtil.groupBillingPeriod(subscriptionServices));
        } catch (ex) {
            console.log("on load subscription ex:", ex);
        }
        onShowLoading(false);
        return subscriptionServices;
    }

    const onShowMessage = (message)=>{
        onShowLoading(false)
        setMessage(message)
    }

    const onTerminate = async (values) => {
        onShowMessage({});
        onShowLoading(true);
        setShowProgress(true);
        setShowConfirmTerminate(false);
        try {
            const { reason_id } = values;
            let service_id = terminateSelected && terminateSelected.service && terminateSelected.service.id ? terminateSelected.service.id : null;
            let serviceFrom = terminateSelected && terminateSelected.service && terminateSelected.service.product ? terminateSelected.service.product : null
            console.log("serviceFrom AAAAAA===", serviceFrom);
            let current_product_id = serviceFrom && serviceFrom.id ? serviceFrom.id : null;
            await onTerminateVumatel(service_id, reason_id, current_product_id);
        } catch (ex) {
            console.log("onTerminate exception===", ex);
        }
        onShowLoading(false)
        //setShowProgress(false);
    }

    const onTerminateVumatel = async (service_id, reason_id, current_product_id) => {
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.onTerminateVumatel(service_id, reason_id, current_product_id);
            console.log("onTerminateVumatel result ====", result);
            if(result.code === 'OK'){
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'terminate_vumatel_success',
                    message: t('terminate_vumatel_success')
                });
                await onTerminateCRM(service_id);
            } else if(result.code === 'VUMATEL_SERVER_ERROR'){
                setActiveStep(0);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: t('SERVER_ERROR')
                });
                setShowButtonClose(true);
            }
            else{
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                setActiveStep(0);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: entityError && entityError.detail && typeof(entityError.detail) === 'string' ? entityError.detail : t('terminate_vumatel_failed')
                });
                setShowButtonClose(true);
            }
        }
        catch(ex){
            console.log("onTerminateVumatel exception===", ex);
        }
        onShowLoading(false)
    }

    const onTerminateCRM = async (service_id) => {
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.onTerminateCRM(service_id);
            console.log("onTerminateCRM result ====", result);
            if(result.code === 'OK'){
                setActiveStep(2);
                setResultProgress({
                    step: 2,
                    status: 'terminate_crm_success',
                    message: t('terminate_crm_success')
                });
                setShowButtonClose(true);
                await onInit();
                setShowProgress(false);
            }else{
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'ERROR',
                    message: t('terminate_crm_failed')
                });
                setShowButtonClose(true);
            }
        }
        catch(ex){
            console.log("onTerminateCRM exception===", ex);
        }
        onShowLoading(false)
    }

    const getSteps = () => {
        return [t('terminate_vumatel'), t('terminate_crm')];
    }

    const onCloseProgress = () => {
        setShowProgress(false);
        setResultProgress({
            step: 0,
            status: null,
            message: null
        });
    }

    const getTerminateReason = async () => {
        let list_reason = [];
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.getTerminateReason();
            console.log("getTerminateReason result ====", result);
            if(result.code == 'OK'){
                list_reason = result.data.filter(x => x.active === true);
                setListReason(list_reason);
                setShowConfirmTerminate(true)
            }
        }
        catch(ex){
            console.log("getTerminateReason exception===", ex);
        }
        onShowLoading(false)
        return list_reason;
    }

    const onConfirmTerminate = async (service) => {
        try{
            setTerminateSelected(service);
            let list_reason = await getTerminateReason();
            if(list_reason && list_reason.length > 0){
                setShowConfirmTerminate(true);
            }
        }
        catch(ex){
            console.log("onConfirmTerminate exception===", ex);
        }
    }

    const onChangeBillingDay = (item) => {
        setSubcriptionSelected(item);
        setShowBillingDay(true);
    }


    return (
        <>
            <SubcriptionsView
                periods={periods}
                subcriptions={subcriptions}
                periodSelected={periodSelected}
                currency={getCurrency()}
                onSwarpService={onSwarpService}                
                onChangeTab={onChangeTab}
                onTerminate={onConfirmTerminate}
                onChangeBillingDay={onChangeBillingDay}
            />
            {showChangeServices && <ChangeServicesView 
                open={showChangeServices}
                changeServices={changeServices}
                currency={getCurrency()}
                onClose={() => setShowChangeServices(false)}
                onEstimateServices={onEstimateServices}
            />}
            {showDetailService && <ServiceDetailController 
                open={showChangeServices}
                service={serviceDetail}
                serviceChangeSelected={serviceChangeSelected}
                subscriptionSelected={subscriptionSelected}
                currency={getCurrency()}
                onClose={() => setShowDetailService(false)}
                onCloseAll={() => {
                    setShowDetailService(false)
                    setShowChangeServices(false)
                }}
                onLoad={onInit}
            />}
            { message.show && <CustomAlert
                open = {message.show}
                message = {message.content}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                onClose = {() => onShowMessage({})}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                showButtonClose={true}
            />}
            {showProgress &&  <OrderProgress
                open={showProgress}
                t={t}
                orderInfo={resultProgress}
                title={t('terminate_service')}
                sub_title={t('terminate_service_progress')}
                steps={getSteps()}
                activeStep={activeStep}
                showButtonClose={showButtonClose}
                onClose={() => onCloseProgress()}
            />}
            {showConfirmTerminate && <TerminateConfirm 
                open={showConfirmTerminate}
                reasonSelected={reasonSelected}
                listReason={listReason}
                onTerminate={onTerminate}
                onClose={() => setShowConfirmTerminate(false)}
            />}
            {showLoading && <CustomLoading open={showLoading}/>}
            {showBillingDay && <ChangeBillingDay 
                open={showBillingDay}
                onClose={() => setShowBillingDay(false)}
                subscriptionSelected={subscriptionSelected}
                onRefresh={onInit}
            />}
        </>
    );
}